import React from 'react';
import { Listing } from '@ha/api/v2/types/Listing';
import { useIntl } from 'ha/i18n';
import { useTrackEvent } from 'ha/modules/Analytics/helpers/TrackEvent';
import { usePage } from 'ha/modules/Page/contexts/PageContext';
import debounce from 'debounce';
import { Card, CardContent, Grid, Typography, units } from '@hbf/dsl';
import {
  ContractTypeOptions,
  ContractTypeOptionsAdvertiser,
} from 'ha/constants/ContractTypes';
import { TextTooltip } from 'ha/components.legacy/TextTooltip';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()({
  cardcontent: {
    padding: units.rem(1),
    '&:last-child': {
      paddingBottom: units.rem(1),
    },
  },
});
const DEBOUNCE_TIME = 500;
const ContractType: React.FC<{
  contractType: Listing['contractType'];
  isAdvertiserVariant?: boolean;
}> = ({ contractType, isAdvertiserVariant }) => {
  const { classes } = useStyles();
  const { T } = useIntl();

  const trackEvent = useTrackEvent();
  const page = usePage();

  const trackContractTypeTooltip = React.useMemo(
    () =>
      debounce(() => {
        trackEvent('Tooltip opened', {
          name: 'contractType',
          contractType,
          opened_from: page.category,
        });
      }, DEBOUNCE_TIME),
    [contractType, page.category, trackEvent],
  );
  const contractTypeOption = isAdvertiserVariant
    ? ContractTypeOptionsAdvertiser[contractType]
    : ContractTypeOptions[contractType];
  return (
    <Grid item xs={12}>
      <Card variant="outlined">
        <CardContent className={classes.cardcontent}>
          <Grid
            item
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={6} data-test-locator="PaymentDialog/contractType">
              <Typography.Paragraph fontWeight="bold" textTransform="uppercase">
                {T('StructuredCosts.LDP.typeofcontract')}
              </Typography.Paragraph>
            </Grid>
            <Grid item xs={6}>
              <Typography.Paragraph align="right">
                {T(contractTypeOption.title)}
                <TextTooltip
                  onOpen={trackContractTypeTooltip}
                  tooltip={T(contractTypeOption.tooltip)}
                />
              </Typography.Paragraph>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Grid>
  );
};

export { ContractType };
